// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Divider,
//   Link,
//   useMediaQuery
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import CustomTypography from "components/Fileds/CustomTypography";
// import { currencySymbol } from "utils/constant";
// import { ORDER_TYPES } from "context/OrderContext";
// import DiscountModal from "components/Modal/DiscountModal";
// import { useAddDiscountOrderMutation, useRemoveDiscountOrderMutation } from "pages/orders/services";

// const PricingSummary = ({ orderDetails, isViewOnly = false }) => {
//   const vendorData = useSelector((state) => state?.posData?.vendor);

//   const [openModal, setOpenModal] = useState(false);
//   const [removeDiscountAPI] = useRemoveDiscountOrderMutation();

//   const platformFeePercent = parseFloat(vendorData?.platform_fee) || 0;
//   const serviceTaxPercent = parseFloat(vendorData?.service_tax) || 0;

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const cartTotal = orderDetails?.orderItems?.reduce((total, item) => {
//     const itemTotal = parseFloat(item.unit_price) * item.quantity
//     const addOnsTotal = item?.orderItemAddons ? item?.orderItemAddons?.reduce((sum, addon) => parseFloat(sum) + parseFloat(addon.addon_price), 0) : 0
//     return total + itemTotal + addOnsTotal * item.quantity
//   }, 0);

//   const handleRemoveDiscount = async () => {
//     try {
//       const tax = (cartTotal * serviceTaxPercent) / 100; // service tax
//       const platformFee = (cartTotal * platformFeePercent) / 100; // platform fee
//       const finalTotal = cartTotal + tax + platformFee;
//       const body = { discount_type: null, discount_value: null, total_amount: finalTotal }

//       const res = await removeDiscountAPI({ id: orderDetails?.id, body });
//     } catch (error) {
//       console.log("error in removeDiscountOrder", error);
//     }
//   }

//   const discountValue = parseFloat(orderDetails?.discount_amount).toFixed(2);
//   const updateCartValue = cartTotal - discountValue;
//   const tax = (updateCartValue * serviceTaxPercent) / 100; // service tax
//   const platformFee = (updateCartValue * platformFeePercent) / 100; // platform fee

//   // const discount = orderDetails?.order_type === ORDER_TYPES.TABLE_BOOKING ? cartTotal * 0.1 : 0 // 10% discount for table booking

//   // const finalTotal = updateCartValue + tax + platformFee;
//   const riderTipAmount = parseFloat(orderDetails?.rider_tip_amount) || 0;
//   let finalTotal = updateCartValue + tax + platformFee;
//   console.log(finalTotal,"finalTotalfinalTotal", updateCartValue,"updateCartValue", tax,"tax", platformFee,"platFormFee")
//   if (orderDetails?.order_type === ORDER_TYPES.DELIVERY) {
//     finalTotal += riderTipAmount;
//   }

//   return (
//     <>
//       <Box className='d-flex'
//         justifyContent={isMobile ? "center" : "flex-end"}
//       >
//         <Card
//           variant="outlined"
//           className="order-customer-info-container"
//           sx={{
//             maxWidth: 450,
//             width: "100%",
//             borderRadius: '10px',
//             border: "1px solid #AFAFAF"
//           }}
//         >
//           <CardContent sx={{ padding: '0px', paddingBottom: '0px !important' }}>
//             <CustomTypography
//               label={"Pricing Summary"}
//               variant={"h6"}
//               sx={{ fontSize: '18px', fontWeight: 600, mb: '12px' }}
//             />
//             <Divider sx={{ borderColor: '#AFAFAF', mb: 2 }} />

//             {/* Order Items */}
//             <Box className='d-flex align-items-center justify-content-between' mb={1}>
//               <CustomTypography
//                 variant={"body2"}
//                 label={"Order Items Total"}
//                 sx={{ color: '#919191', fontWeight: 400, mb: 0, }}
//               />
//               <CustomTypography
//                 variant={"body2"}
//                 label={`${currencySymbol(vendorData?.currency)}${parseFloat(cartTotal)?.toFixed(2)}`}
//                 sx={{ fontSize: '18px', fontWeight: 500, color: theme.palette.drawermenuitem.main, mb: 0 }}
//               />
//             </Box>

//             {/* Discounts */}
//             <Box display="flex" justifyContent="space-between" mb={1}>
//               {discountValue == 0 ? <Typography
//                 variant="body2"
//                 color="success.main"
//                 sx={{ cursor: "pointer", color: '#1F9619', fontSize: '14px', fontWeight: '400' }}
//               >
//                 No Discounts
//                 {!isViewOnly && (<Link component="button" sx={{ color: '#000', fontSize: '14px', fontWeight: '400', marginLeft: '8px' }}
//                   onClick={() => setOpenModal(true)}
//                 >Add</Link>)}
//               </Typography> :
//                 <>
//                   <Typography
//                     variant={"body2"}
//                     sx={{ color: '#1F9619', fontSize: '14px', fontWeight: '400', mb: 0 }}
//                   >
//                     Discount
//                     {!isViewOnly && (<Link
//                       component="button"
//                       sx={{ color: '#D41616', fontSize: '14px', fontWeight: '400', marginLeft: '8px', alignSelf: 'center' }}
//                       onClick={handleRemoveDiscount} // or your handler to remove the discount
//                     >
//                       Remove
//                     </Link>)}
//                   </Typography>
//                   <CustomTypography
//                     variant={"body2"}
//                     label={`- ${currencySymbol(vendorData?.currency)}${discountValue}`}
//                     sx={{ color: '#1F9619', fontSize: '14px', fontWeight: '400', mb: 0 }}
//                   />
//                 </>
//               }
//             </Box>

//             {/* Service Tax */}
//             <Box className='d-flex align-items-center justify-content-between' mb={1}>
//               <CustomTypography
//                 variant={"body2"}
//                 label={`Service Tax (${vendorData?.service_tax}%)`}
//                 sx={{ color: '#919191', fontWeight: 400, mb: 0, }}
//               />
//               <CustomTypography
//                 variant={"body2"}
//                 label={`${currencySymbol(vendorData?.currency)}${parseFloat(tax)?.toFixed(2) || 0.00}`}
//                 sx={{ fontSize: '18px', fontWeight: 500, color: theme.palette.drawermenuitem.main, mb: 0 }}
//               />
//             </Box>

//             {/* Platform Fee */}
//             <Box className='d-flex align-items-center justify-content-between' mb={orderDetails?.rider_tip_amount > 0 ? 1 : 2}>
//               <CustomTypography
//                 variant={"body2"}
//                 label={`Platform Fee (${vendorData?.platform_fee}%)`}
//                 sx={{ color: '#919191', fontWeight: 400, mb: 0, }}
//               />
//               <CustomTypography
//                 variant={"body2"}
//                 label={`${currencySymbol(vendorData?.currency)}${parseFloat(platformFee)?.toFixed(2) || 0.00}`}
//                 sx={{ fontSize: '18px', fontWeight: 500, color: theme.palette.drawermenuitem.main, mb: 0 }}
//               />
//             </Box>

//             {/* Delivery Tip */}
//             {orderDetails?.order_type === ORDER_TYPES.DELIVERY && riderTipAmount > 0 && (
//               <Box className='d-flex align-items-center justify-content-between' mb={2}>
//                 <CustomTypography
//                   variant={"body2"}
//                   label={`Delivery Tip`}
//                   sx={{ color: '#919191', fontWeight: 400, mb: 0, }}
//                 />
//                 <CustomTypography
//                   variant={"body2"}
//                   label={`${currencySymbol(vendorData?.currency)}${parseFloat(riderTipAmount)?.toFixed(2) || 0.00}`}
//                   sx={{ fontSize: '18px', fontWeight: 500, color: theme.palette.drawermenuitem.main, mb: 0 }}
//                 />
//               </Box>
//             )}

//             {/* <Divider sx={{ my: 1.5 }} /> */}

//             {/* Order Total */}
//             {/* <Box className='d-flex align-items-center justify-content-between'>
//             <CustomTypography
//                 variant={"body2"}
//                 label={`Order Total`}
//                 sx={{fontWeight: 600, mb:0 , fontSize:'18px'}}
//             />
//             <CustomTypography
//                 variant={"body2"}
//                 label={`${currencySymbol(vendorData?.currency)}${finalTotal || 0.00}`}
//                 sx={{fontSize:'18px', fontWeight:600, mb:0}}
//             />
//           </Box> */}

//             {/* Order Total */}
//             <Box className='d-flex align-items-center'>
//               <CustomTypography
//                 variant="body2"
//                 label="Order Total"
//                 sx={{ fontWeight: 600, fontSize: '18px', whiteSpace: 'nowrap', mb: 0 }}
//               />

//               <Box sx={{ flex: 1, borderBottom: '2px dotted #919191', mx: 2 }} />

//               <CustomTypography
//                 variant="body2"
//                 label={`${currencySymbol(vendorData?.currency)}${((Math.floor(parseFloat(finalTotal) * 100) / 100).toFixed(2) || 0.00)}`}
//                 sx={{ fontSize: '18px', fontWeight: 600, whiteSpace: 'nowrap', mb: 0 }}
//               />
//             </Box>

//           </CardContent>
//         </Card>
//       </Box>
//       <DiscountModal
//         open={openModal}
//         onClose={() => setOpenModal(false)}
//         orderDetails={orderDetails}
//         orderItemTotal={cartTotal}
//       />
//     </>
//   );
// };

// export default PricingSummary;



import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Link,
  useMediaQuery,
  Skeleton,
  Tooltip
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomTypography from "components/Fileds/CustomTypography";
import { currencySymbol } from "utils/constant";
import { ORDER_TYPES } from "context/OrderContext";
import DiscountModal from "components/Modal/DiscountModal";
import { useAddDiscountOrderMutation, useManagePackageChargesMutation, useRemoveDiscountOrderMutation } from "pages/orders/services";
import CustomCheckbox from "components/Fileds/CustomCheckbox";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const PricingSummary = ({ orderDetails, isViewOnly = false, refetch }) => {
  const vendorData = useSelector((state) => state?.posData?.vendor);

  const [openModal, setOpenModal] = useState(false);
  const [removeDiscountAPI] = useRemoveDiscountOrderMutation();
  const [managePackageCharges] = useManagePackageChargesMutation();
  const [isChargesRemoved, setIsChargesRemoved] = useState(false);

  // Sync isChargesRemoved state from orderDetails when it changes
  useEffect(() => {
    if (orderDetails?.is_charges_removed !== undefined) {
      setIsChargesRemoved(!!orderDetails.is_charges_removed);
    }
  }, [orderDetails?.is_charges_removed]);

  // Determine if discount can be applied based on order_source and order_type
  const canApplyDiscount =
    orderDetails?.order_source === "pos" ||
    (orderDetails?.order_source === "customer" && orderDetails?.order_type === "booking");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ✅ SAFE NUMBER HELPER (prevents NaN)
  const safeNumber = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const isCustomerOrder = orderDetails?.order_source === "customer";
  const minCap = orderDetails?.marketplace_fee_min_cap;
  const maxCap = orderDetails?.marketplace_fee_max_cap;

  const platformFeePercent = isCustomerOrder
    ? (orderDetails?.marketplace_fee_percentage !== undefined && orderDetails?.marketplace_fee_percentage !== null
      ? safeNumber(orderDetails.marketplace_fee_percentage)
      : safeNumber(vendorData?.platform_fee))
    : 0; // POS order: fee absorbed by vendor

  const displayPlatformFeePercent = isCustomerOrder
    ? (orderDetails?.marketplace_fee_percentage !== undefined && orderDetails?.marketplace_fee_percentage !== null
      ? orderDetails.marketplace_fee_percentage
      : (vendorData?.platform_fee || 0))
    : 0;

  const serviceTaxPercent = safeNumber(vendorData?.service_tax);

  const calculatePlatformFee = (amount, percent) => {
    if (amount <= 0) return 0;
    let fee = (amount * percent) / 100;
    if (isCustomerOrder) {
      if (minCap !== null && minCap !== undefined && minCap !== "") {
        const min = parseFloat(minCap);
        if (!isNaN(min) && fee < min) {
          fee = min;
        }
      }
      if (maxCap !== null && maxCap !== undefined && maxCap !== "") {
        const max = parseFloat(maxCap);
        if (!isNaN(max) && fee > max) {
          fee = max;
        }
      }
    }
    return fee;
  };

  const cartTotal =
    orderDetails?.orderItems?.reduce((total, item) => {
      const itemTotal = safeNumber(item.unit_price) * item.quantity;

      const addOnsTotal = item?.orderItemAddons
        ? item.orderItemAddons.reduce(
          (sum, addon) => sum + safeNumber(addon.addon_price),
          0
        )
        : 0;

      return total + itemTotal + addOnsTotal * item.quantity;
    }, 0) || 0;

  const promoDiscountAmount = safeNumber(orderDetails?.offer_discount_amount);
  const promoCode = orderDetails?.promo_code || "";

  const handleRemoveDiscount = async () => {
    try {
      const subtotalAfterPromo = Math.max(0, cartTotal - promoDiscountAmount);
      const tax = (subtotalAfterPromo * serviceTaxPercent) / 100;
      const platformFee = calculatePlatformFee(subtotalAfterPromo, platformFeePercent);
      let finalTotal = subtotalAfterPromo + tax + platformFee;

      if (orderDetails?.package_charge > 0 && !isChargesRemoved) {
        finalTotal += safeNumber(orderDetails?.package_charge);
      }
      if (orderDetails?.order_type === ORDER_TYPES.DELIVERY || orderDetails?.order_type === ORDER_TYPES.PHONE_ORDER || orderDetails?.order_type === 'phone_order') {
        finalTotal += riderTipAmount;
      }
      if ((orderDetails?.order_type === ORDER_TYPES.DELIVERY || orderDetails?.order_type === ORDER_TYPES.PHONE_ORDER || orderDetails?.order_type === 'phone_order') && orderDetails?.delivery_fee > 0) {
        finalTotal += safeNumber(orderDetails?.delivery_fee);
      }
      const roundedTotal = Math.floor(finalTotal * 100) / 100;

      const body = {
        discount_type: null,
        discount_value: null,
        total_amount: roundedTotal.toFixed(2)
      };

      await removeDiscountAPI({ id: orderDetails?.id, body });
    } catch (error) {
      console.log("error in removeDiscountOrder", error);
    }
  };

  const discountValue = safeNumber(orderDetails?.discount_amount);
  const updateCartValue = Math.max(0, cartTotal - discountValue - promoDiscountAmount);

  const tax = (updateCartValue * serviceTaxPercent) / 100;
  const platformFee = calculatePlatformFee(updateCartValue, platformFeePercent);

  const riderTipAmount = safeNumber(orderDetails?.rider_tip_amount);

  // Loyalty points discount — only for customer marketplace orders, read directly from DB response
  const loyaltyPointsDiscount = isCustomerOrder ? safeNumber(orderDetails?.loyalty_points_discount) : 0;

  let finalTotal = updateCartValue + tax + platformFee;

  if (orderDetails?.order_type === ORDER_TYPES.DELIVERY || orderDetails?.order_type === ORDER_TYPES.PHONE_ORDER || orderDetails?.order_type === 'phone_order') {
    finalTotal += riderTipAmount;
  }
  if ((orderDetails?.order_type === ORDER_TYPES.DELIVERY || orderDetails?.order_type === ORDER_TYPES.PHONE_ORDER || orderDetails?.order_type === 'phone_order') && orderDetails?.delivery_fee > 0) {
    finalTotal += safeNumber(orderDetails?.delivery_fee);
  }
  // Only add package charge if it hasn't been removed
  if (orderDetails?.package_charge > 0 && !isChargesRemoved) {
    finalTotal += safeNumber(orderDetails?.package_charge);
  }
  // Subtract loyalty points discount from Order Total for customer orders
  if (loyaltyPointsDiscount > 0) {
    finalTotal = Math.max(0, finalTotal - loyaltyPointsDiscount);
  }

  // Handler to toggle package charge removal
  const handleRemovePackageCharge = async (checked) => {
    setIsChargesRemoved(checked);
    try {
      // Recalculate total_amount without/with package charge
      let recalcTotal = updateCartValue + tax + platformFee;
      if (orderDetails?.order_type === ORDER_TYPES.DELIVERY || orderDetails?.order_type === ORDER_TYPES.PHONE_ORDER || orderDetails?.order_type === 'phone_order') {
        recalcTotal += riderTipAmount;
      }
      if ((orderDetails?.order_type === ORDER_TYPES.DELIVERY || orderDetails?.order_type === ORDER_TYPES.PHONE_ORDER || orderDetails?.order_type === 'phone_order') && orderDetails?.delivery_fee > 0) {
        recalcTotal += safeNumber(orderDetails?.delivery_fee);
      }
      if (!checked && orderDetails?.package_charge > 0) {
        recalcTotal += safeNumber(orderDetails?.package_charge);
      }
      const roundedTotal = Math.floor(recalcTotal * 100) / 100;

      await managePackageCharges({
        id: orderDetails?.id,
        body: {
          ischargesremoved: checked,
          total_amount: roundedTotal.toFixed(2),
        },
      });
      if (refetch) refetch();
    } catch (error) {
      console.log("Error in remove package charge", error);
      setIsChargesRemoved(!checked); // revert on error
    }
  };
  const grandTotal = Math.floor(finalTotal * 100) / 100; // Round down to 2 decimal places
  const alreadyPaid = parseFloat(orderDetails?.paid_amount).toFixed(2) || 0;
  const remainingAmount = grandTotal - alreadyPaid;

  // ✅ CHECK DATA READY (prevents flicker)
  const isDataReady = orderDetails && vendorData;

  const isUnpaid = orderDetails?.payment_status === "unpaid";
  const isCompleted = orderDetails?.order_status === "completed";
  const hideCheckbox = !isChargesRemoved && !isUnpaid && isCompleted;

  // POS Vendor Settlement / Payout Calculation
  const isPosOrder = orderDetails?.order_source === "pos" || !isCustomerOrder || !!orderDetails?.is_fee_deducted_from_vendor;
  const isCompletedOrPast = isViewOnly || orderDetails?.order_status === "completed" || orderDetails?.payment_status === "paid";
  const shouldShowVendorPayout = isPosOrder && isCompletedOrPast;

  const paymentMode = (orderDetails?.payment_mode || "cash").toLowerCase();
  const isCashPayment = paymentMode === "cash";

  const resolvePosFeeDetails = () => {
    const savedFee = orderDetails?.platform_fee !== null && orderDetails?.platform_fee !== undefined
      ? safeNumber(orderDetails.platform_fee)
      : null;
    const savedPct = orderDetails?.pos_fee_percentage !== null && orderDetails?.pos_fee_percentage !== undefined
      ? safeNumber(orderDetails.pos_fee_percentage)
      : null;
    const savedMaxCap = orderDetails?.pos_fee_max_cap;
    const savedMinCap = orderDetails?.pos_fee_min_cap;

    if (savedFee !== null && savedPct !== null && (savedFee > 0 || isCashPayment || savedPct === 0)) {
      return {
        feeAmount: savedFee,
        feePercentage: savedPct,
        maxCap: savedMaxCap,
        minCap: savedMinCap,
      };
    }

    if (isCashPayment) {
      return {
        feeAmount: 0,
        feePercentage: 0,
        maxCap: null,
        minCap: null,
      };
    }

    const posCardFeeObj = vendorData?.pos_card_fee ||
      (vendorData?.fees_and_commission && vendorData.fees_and_commission.find((f) => !f.is_marketplace && !f.is_cash));

    let feePct = 0;
    let minCap = null;
    let maxCap = null;

    if (posCardFeeObj) {
      feePct = safeNumber(posCardFeeObj.percentage);
      minCap = posCardFeeObj.min_cap;
      maxCap = posCardFeeObj.max_cap;
    }

    let calculatedFee = (cartTotal * feePct) / 100;
    if (minCap !== null && minCap !== undefined && minCap !== "") {
      const min = parseFloat(minCap);
      if (!isNaN(min) && calculatedFee < min) calculatedFee = min;
    }
    if (maxCap !== null && maxCap !== undefined && maxCap !== "") {
      const max = parseFloat(maxCap);
      if (!isNaN(max) && calculatedFee > max) calculatedFee = max;
    }

    return {
      feeAmount: calculatedFee,
      feePercentage: feePct,
      maxCap,
      minCap,
    };
  };

  const posFeeDetails = resolvePosFeeDetails();
  const posFeeAmount = posFeeDetails.feeAmount;
  const posFeePct = posFeeDetails.feePercentage;

  const vendorPayoutAmount =
    orderDetails?.vendor_payout_amount !== null &&
    orderDetails?.vendor_payout_amount !== undefined &&
    safeNumber(orderDetails.vendor_payout_amount) > 0
      ? safeNumber(orderDetails.vendor_payout_amount)
      : Math.max(0, finalTotal - posFeeAmount);

  return (
    <>
      <Box
        className="d-flex"
        justifyContent={isMobile ? "center" : "flex-end"}
      >
        <Card
          variant="outlined"
          className="order-customer-info-container"
          sx={{
            maxWidth: 450,
            width: "100%",
            borderRadius: "10px",
            border: "1px solid #AFAFAF"
          }}
        >
          <CardContent sx={{ padding: "0px", paddingBottom: "0px !important" }}>
            <CustomTypography
              label={"Pricing Summary"}
              variant={"h6"}
              sx={{ fontSize: "18px", fontWeight: 600, mb: "12px" }}
            />
            <Divider sx={{ borderColor: "#AFAFAF", mb: 2 }} />

            {/* Order Items */}
            <Box
              className="d-flex align-items-center justify-content-between"
              mb={1}
            >
              <CustomTypography
                variant={"body2"}
                label={"Order Items Total"}
                sx={{ color: "#919191", fontWeight: 400, mb: 0 }}
              />

              {isDataReady ? (
                <CustomTypography
                  variant={"body2"}
                  label={`${currencySymbol(vendorData?.currency)}${cartTotal.toFixed(2)}`}
                  sx={{
                    fontSize: "18px",
                    fontWeight: 500,
                    color: theme.palette.drawermenuitem.main,
                    mb: 0
                  }}
                />
              ) : (
                <Skeleton width={80} height={20} />
              )}
            </Box>

            {/* Promo Discount */}
            {promoDiscountAmount > 0 && (
              <Box
                className="d-flex align-items-center justify-content-between"
                mb={1}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#1F9619",
                    fontSize: "14px",
                    fontWeight: "500",
                    mb: 0
                  }}
                >
                  Promo Discount {promoCode ? `(${promoCode})` : ""}
                </Typography>

                {isDataReady ? (
                  <CustomTypography
                    variant={"body2"}
                    label={`-${currencySymbol(vendorData?.currency)}${promoDiscountAmount.toFixed(2)}`}
                    sx={{
                      color: "#1F9619",
                      fontSize: "18px",
                      fontWeight: 500,
                      mb: 0
                    }}
                  />
                ) : (
                  <Skeleton width={60} height={20} />
                )}
              </Box>
            )}

            {/* Discounts — only show for eligible orders */}
            {canApplyDiscount && (discountValue > 0 || (!isViewOnly && !isCompleted)) && (
              <Box display="flex" justifyContent="space-between" mb={1}>
                {discountValue === 0 ? (
                  <Typography
                    variant="body2"
                    sx={{
                      cursor: "pointer",
                      color: "#1F9619",
                      fontSize: "14px",
                      fontWeight: "400"
                    }}
                  >
                    No Discounts
                    {!isViewOnly && (
                      <Link
                        component="button"
                        sx={{
                          color: "#000",
                          fontSize: "14px",
                          fontWeight: "400",
                          marginLeft: "8px"
                        }}
                        onClick={() => setOpenModal(true)}
                      >
                        Add
                      </Link>
                    )}
                  </Typography>
                ) : (
                  <>
                    <Typography
                      variant={"body2"}
                      sx={{
                        color: "#1F9619",
                        fontSize: "14px",
                        fontWeight: "400",
                        mb: 0
                      }}
                    >
                      Discount
                      {!isViewOnly && !isCompleted && (
                        <Link
                          component="button"
                          sx={{
                            color: "#D41616",
                            fontSize: "14px",
                            fontWeight: "400",
                            marginLeft: "8px"
                          }}
                          onClick={handleRemoveDiscount}
                        >
                          Remove
                        </Link>
                      )}
                    </Typography>

                    {isDataReady ? (
                      <CustomTypography
                        variant={"body2"}
                        label={`- ${currencySymbol(vendorData?.currency)}${discountValue.toFixed(2)}`}
                        sx={{
                          color: "#1F9619",
                          fontSize: "14px",
                          fontWeight: "400",
                          mb: 0
                        }}
                      />
                    ) : (
                      <Skeleton width={60} height={20} />
                    )}
                  </>
                )}
              </Box>
            )}

            {/* Service Tax */}
            <Box
              className="d-flex align-items-center justify-content-between"
              mb={1}
            >
              <CustomTypography
                variant={"body2"}
                label={`Service Tax (${vendorData?.service_tax || 0}%)`}
                sx={{ color: "#919191", fontWeight: 400, mb: 0 }}
              />

              {isDataReady ? (
                <CustomTypography
                  variant={"body2"}
                  label={`${currencySymbol(vendorData?.currency)}${tax.toFixed(2)}`}
                  sx={{
                    fontSize: "18px",
                    fontWeight: 500,
                    color: theme.palette.drawermenuitem.main,
                    mb: 0
                  }}
                />
              ) : (
                <Skeleton width={60} height={20} />
              )}
            </Box>

            {/* Platform Fee - only charged to customer for marketplace orders */}
            {isCustomerOrder && (
            <Box
              className="d-flex align-items-center justify-content-between"
              // mb={orderDetails?.rider_tip_amount > 0 ? 1 : 2}
              mb={1}
            >
              <Box className="d-flex align-items-center">
                <CustomTypography
                  variant={"body2"}
                  label={`Platform Fee (${displayPlatformFeePercent}%)`}
                  sx={{ color: "#919191", fontWeight: 400, mb: 0 }}
                />
                {isCustomerOrder && (
                  <Tooltip
                    title={
                      <Box sx={{ p: 0.5 }}>
                        <Typography
                          variant="caption"
                          sx={{ display: "block", fontSize: "11px", fontWeight: 600, mb: 0.25 }}
                        >
                          Fee Cap Limits
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ display: "block", fontSize: "11px" }}
                        >
                          Min Cap: {minCap !== null && minCap !== undefined && minCap !== "" ? `${currencySymbol(vendorData?.currency) || "£"}${parseFloat(minCap).toFixed(2)}` : "None"}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ display: "block", fontSize: "11px" }}
                        >
                          Max Cap: {maxCap !== null && maxCap !== undefined && maxCap !== "" ? `${currencySymbol(vendorData?.currency) || "£"}${parseFloat(maxCap).toFixed(2)}` : "None"}
                        </Typography>
                      </Box>
                    }
                    arrow
                    placement="top"
                  >
                    <InfoOutlinedIcon
                      sx={{
                        fontSize: "16px",
                        color: "#919191",
                        cursor: "pointer",
                        ml: 0.5,
                        "&:hover": { color: "#333" }
                      }}
                    />
                  </Tooltip>
                )}
              </Box>

              {isDataReady ? (
                <CustomTypography
                  variant={"body2"}
                  label={`${currencySymbol(
                    vendorData?.currency
                  )}${platformFee.toFixed(2)}`}
                  sx={{
                    fontSize: "18px",
                    fontWeight: 500,
                    color: theme.palette.drawermenuitem.main,
                    mb: 0
                  }}
                />
              ) : (
                <Skeleton width={60} height={20} />
              )}
            </Box>
            )}

            {/* Delivery Tip */}
            {(orderDetails?.order_type === ORDER_TYPES.DELIVERY || orderDetails?.order_type === ORDER_TYPES.PHONE_ORDER || orderDetails?.order_type === 'phone_order') &&
              riderTipAmount > 0 && (
                <Box
                  className="d-flex align-items-center justify-content-between"
                  mb={1}
                >
                  <CustomTypography
                    variant={"body2"}
                    label={`Delivery Tip`}
                    sx={{ color: "#919191", fontWeight: 400, mb: 0 }}
                  />

                  <CustomTypography
                    variant={"body2"}
                    label={`${currencySymbol(
                      vendorData?.currency
                    )}${riderTipAmount.toFixed(2)}`}
                    sx={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: theme.palette.drawermenuitem.main,
                      mb: 0
                    }}
                  />
                </Box>
              )}

            {
              orderDetails?.delivery_fee > 0 && (
                <Box
                  className="d-flex align-items-center justify-content-between"
                  mb={1}
                >
                  <CustomTypography
                    variant={"body2"}
                    label={`Delivery Fee`}
                    sx={{ color: "#919191", fontWeight: 400, mb: 0 }}
                  />

                  <CustomTypography
                    variant={"body2"}
                    label={`${currencySymbol(
                      vendorData?.currency
                    )}${parseFloat(orderDetails?.delivery_fee).toFixed(2)}`}
                    sx={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: theme.palette.drawermenuitem.main,
                      mb: 0
                    }}
                  />
                </Box>
              )
            }

            {
              orderDetails?.package_charge > 0 && (
                <Box
                  className="d-flex align-items-center justify-content-between"
                  mb={1}
                >
                  <CustomTypography
                    variant={"body2"}
                    label={`Package Charge`}
                    sx={{
                      color: "#919191",
                      fontWeight: 400,
                      mb: 0,
                      // textDecoration: isChargesRemoved ? "line-through" : "none",
                    }}
                  />

                  <CustomTypography
                    variant={"body2"}
                    label={`${currencySymbol(
                      vendorData?.currency
                    )}${isChargesRemoved ? "0.00" : parseFloat(orderDetails?.package_charge).toFixed(2)}`}
                    sx={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: theme.palette.drawermenuitem.main,
                      mb: 0,
                      // textDecoration: isChargesRemoved ? "line-through" : "none",
                    }}
                  />
                </Box>
              )
            }

            {/* Loyalty Points Discount — only for customer orders */}
            {isCustomerOrder && safeNumber(orderDetails?.loyalty_points_discount) > 0 && (
              <Box
                className="d-flex align-items-center justify-content-between"
                mb={1}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#1F9619",
                    fontSize: "14px",
                    fontWeight: "500",
                    mb: 0
                  }}
                >
                  Loyalty Points Discount ({safeNumber(orderDetails?.loyalty_points_redeemed)} pts)
                </Typography>

                {isDataReady ? (
                  <CustomTypography
                    variant={"body2"}
                    label={`-${currencySymbol(vendorData?.currency)}${safeNumber(orderDetails?.loyalty_points_discount).toFixed(2)}`}
                    sx={{
                      color: "#1F9619",
                      fontSize: "18px",
                      fontWeight: 500,
                      mb: 0
                    }}
                  />
                ) : (
                  <Skeleton width={60} height={20} />
                )}
              </Box>
            )}

                        {/* Remove package charge checkbox — only for POS take-away orders */}
            {orderDetails?.package_charge > 0 && orderDetails?.order_source === "pos" && !hideCheckbox && (
              <Box mb={1}>
                <CustomCheckbox
                  label={"Remove package charge"}
                  checked={isChargesRemoved}
                  disabled={!isUnpaid || isCompleted}
                  onChange={(e) => handleRemovePackageCharge(e.target.checked)}
                />
              </Box>
            )}

            {/* Order Total */}
            <Box className="d-flex align-items-center">
              <CustomTypography
                variant="body2"
                label="Order Total"
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  whiteSpace: "nowrap",
                  mb: 0
                }}
              />

              <Box
                sx={{
                  flex: 1,
                  borderBottom: "2px dotted #919191",
                  mx: 2
                }}
              />

              {isDataReady ? (
                <CustomTypography
                  variant="body2"
                  label={`${currencySymbol(
                    vendorData?.currency
                  )}${(Math.floor(finalTotal * 100) / 100).toFixed(2)}`}
                  sx={{
                    fontSize: "18px",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    mb: 0
                  }}
                />
              ) : (
                <Skeleton width={80} height={25} />
              )}
            </Box>
            {/* Min booking amount */}
            {orderDetails?.order_source === "customer" && orderDetails?.order_type == "booking" && orderDetails?.payment_status == "part_paid" && orderDetails?.min_booking_amount > 0 &&
              (
                <Box
                  className="d-flex align-items-center justify-content-between"
                  my={1}
                >
                  <CustomTypography
                    variant={"body2"}
                    label={`Min booking amount paid by customer`}
                    sx={{ color: "#919191", fontWeight: 400, mb: 0 }}
                  />

                  <CustomTypography
                    variant={"body2"}
                    label={`- ${currencySymbol(
                      vendorData?.currency
                    )}${parseFloat(orderDetails?.min_booking_amount).toFixed(2)}`}
                    sx={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: theme.palette.drawermenuitem.main,
                      mb: 0
                    }}
                  />
                </Box>
              )}

            {/* Grand Total */}
            {orderDetails?.payment_status == "part_paid" && orderDetails?.order_source === "customer" && orderDetails?.order_type == "booking" &&
              <Box className="d-flex align-items-center">
                <CustomTypography
                  variant="body2"
                  label="Grand Total"
                  sx={{
                    fontWeight: 600,
                    fontSize: "18px",
                    whiteSpace: "nowrap",
                    mb: 0
                  }}
                />

                <Box
                  sx={{
                    flex: 1,
                    borderBottom: "2px dotted #919191",
                    mx: 2
                  }}
                />

                {isDataReady ? (
                  <CustomTypography
                    variant="body2"
                    label={`${currencySymbol(
                      vendorData?.currency
                    )}${(Math.floor(remainingAmount * 100) / 100).toFixed(2)}`}
                    sx={{
                      fontSize: "18px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      mb: 0
                    }}
                  />
                ) : (
                  <Skeleton width={80} height={25} />
                )}
              </Box>}
            {/* Vendor Payout / Net Received Section for Completed / Past Orders */}
            {shouldShowVendorPayout && (
              <Box sx={{ mt: 2.5, pt: 2, borderTop: "1px dashed #d1d5db" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      color: "#475569",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      fontSize: "11px"
                    }}
                  >
                    Vendor Settlement / Payout
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#64748b",
                      fontSize: "11px",
                      fontWeight: 500,
                      textTransform: "capitalize"
                    }}
                  >
                    Paid via {orderDetails?.payment_mode || "Cash"}
                  </Typography>
                </Box>

                {/* Platform Fee Deducted */}
                <Box
                  className="d-flex align-items-center justify-content-between"
                  sx={{ mb: 1 }}
                >
                  <Box className="d-flex align-items-center">
                    <CustomTypography
                      variant={"body2"}
                      label={`Platform Fee (${posFeePct}%${posFeeDetails.maxCap ? ` · Max ${currencySymbol(vendorData?.currency)}${parseFloat(posFeeDetails.maxCap).toFixed(2)}` : ""})`}
                      sx={{ color: posFeeAmount > 0 ? "#D32F2F" : "#64748b", fontWeight: 400, mb: 0, fontSize: "14px" }}
                    />
                    {(posFeeDetails.maxCap || posFeeDetails.minCap) && (
                      <Tooltip
                        title={
                          <Box sx={{ p: 0.5 }}>
                            <Typography variant="caption" sx={{ display: "block", fontSize: "11px", fontWeight: 600, mb: 0.25 }}>
                              POS Fee Cap Limits
                            </Typography>
                            {posFeeDetails.minCap && (
                              <Typography variant="caption" sx={{ display: "block", fontSize: "11px" }}>
                                Min Cap: {currencySymbol(vendorData?.currency)}{parseFloat(posFeeDetails.minCap).toFixed(2)}
                              </Typography>
                            )}
                            {posFeeDetails.maxCap && (
                              <Typography variant="caption" sx={{ display: "block", fontSize: "11px" }}>
                                Max Cap: {currencySymbol(vendorData?.currency)}{parseFloat(posFeeDetails.maxCap).toFixed(2)}
                              </Typography>
                            )}
                          </Box>
                        }
                        arrow
                        placement="top"
                      >
                        <InfoOutlinedIcon
                          sx={{
                            fontSize: "15px",
                            color: "#919191",
                            cursor: "pointer",
                            ml: 0.5,
                            "&:hover": { color: "#333" }
                          }}
                        />
                      </Tooltip>
                    )}
                  </Box>

                  <CustomTypography
                    variant={"body2"}
                    label={`${posFeeAmount > 0 ? "- " : ""}${currencySymbol(vendorData?.currency)}${posFeeAmount.toFixed(2)}`}
                    sx={{
                      fontSize: "15px",
                      fontWeight: 500,
                      color: posFeeAmount > 0 ? "#D32F2F" : "#64748b",
                      mb: 0
                    }}
                  />
                </Box>

                {/* Net Received / Vendor Payout */}
                <Box
                  className="d-flex align-items-center justify-content-between"
                  sx={{
                    p: 1.5,
                    borderRadius: "8px",
                    backgroundColor: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    mt: 1.5
                  }}
                >
                  <Box>
                    <CustomTypography
                      variant="body2"
                      label="You Receive"
                      sx={{
                        fontWeight: 700,
                        fontSize: "15px",
                        color: "#166534",
                        mb: 0
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ color: "#15803d", fontSize: "11px", display: "block" }}
                    >
                      Net payout after platform fee deduction
                    </Typography>
                  </Box>

                  <CustomTypography
                    variant="body1"
                    label={`${currencySymbol(vendorData?.currency)}${vendorPayoutAmount.toFixed(2)}`}
                    sx={{
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#166534",
                      mb: 0
                    }}
                  />
                </Box>
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>

      <DiscountModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        orderDetails={orderDetails}
        orderItemTotal={cartTotal}
      />
    </>
  );
};

export default PricingSummary;